import type { locales, pathnames } from "@/config";

type Locale = (typeof locales)[number];

/**
 * Blog posts written only in some locales. Elsewhere the page 404s and stays
 * out of links, the sitemap and the language menu. Kept apart from
 * blog-posts.ts, which imports next-intl/server, so the client-side language
 * menu can read it. Add a locale here when its translation ships.
 */
export const BLOG_POST_LOCALES = {
  "/blog/collect-wedding-photos-from-guests": ["da", "sv", "no"],
} as const satisfies Partial<Record<keyof typeof pathnames, readonly Locale[]>>;

/** The locales a route exists in, or undefined when it exists in all of them. */
export function getRouteLocales(pathname: string): readonly Locale[] | undefined {
  return (BLOG_POST_LOCALES as Partial<Record<string, readonly Locale[]>>)[pathname];
}
